const types = {
    audial: 'Аудиал',
    visual: 'Визуал',
    kinesthetic: 'Кинестетик',
    discrete: 'Дискрет',
};

export { types };
